module.exports = __webpack_public_path__ + "static/media/nightowl-demo.dbf37fc8.gif";